import { useServicesContext } from "@/modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { UserProfileDraftDto } from "@/modules/users/gateway/usersDto"
import { usersKeys } from "@/modules/users/gateway/usersKeys"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { useAppStateActions } from "@/modules/auth/store/useAppStateStore"

export function useUpdateUser() {
  const { userProfileApi } = useServicesContext()
  const queryClient = useQueryClient()
  const { setAppStateUser } = useAppStateActions()

  return useMutation({
    mutationFn: async (user: Partial<UserProfileDraftDto>) => {
      return await userProfileApi.update(user)
    },
    onSuccess: (user) => {
      queryClient.setQueryData(usersKeys.me(), user)
      setAppStateUser({ user: UserProfileEntity.fromDto(user) })
    },
  })
}
